import { render, staticRenderFns } from "./DepositPage.vue?vue&type=template&id=52ce183b&scoped=true"
import script from "./DepositPage.vue?vue&type=script&lang=ts"
export * from "./DepositPage.vue?vue&type=script&lang=ts"
import style0 from "./DepositPage.vue?vue&type=style&index=0&id=52ce183b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ce183b",
  null
  
)

export default component.exports